export default __webpack_public_path__ + "static/media/pate.aa794833.jpg";